module.exports = __webpack_public_path__ + "static/media/1POLICY9.9ae84e8c.jpg";